<template>
  <span v-if="new RegExp(highLightStr).test(text)">
    {{text.substr(0, text.indexOf(highLightStr))}}<span :style="{color: color}">{{highLightStr}}</span>{{text.substr(text.indexOf(highLightStr) + highLightStr.length)}}
  </span>
  <span v-else>{{text}}</span>
</template>

<script>
  export default {
    name: 'dol-high-light',
    props: {
      text: {type: String, default: ''},                     //原文字
      highLightStr: {type: String, default: ''},             //高亮文字
      color: {type: String, default: '#f50'},   //高亮颜色
    },
  }
</script>
